import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const HostedQuikForm = ({ match }) => {
  const query = new URLSearchParams(window.location.search);
  const quikId = query.get("quikId");
  const raw = localStorage.getItem('quikform');
  const quik = raw && JSON.parse(raw);
  const html = quik.id === quikId && quik.html;

  if (html) {
    return <Form html={html} />
  } else {
    return <NotFound />
  }
};

// React.memo should avoid rerendering when html has not changed
const Form = React.memo(({ html }) => {
  window.document.open();
  window.document.write(html);
  window.document.close();
  return null;
});

const NotFound = () => (
  <Grid
    container
    direction="column"
    alignItems="center"
    justify="center"
  >
    <Grid item style={{ marginTop: '20vh' }}>
      <Typography align='center'>
        The form session was not found. It may have expired. Return to the portfolio summary page to resume.
      </Typography>
    </Grid>
  </Grid>
);

export default HostedQuikForm



// WEBPACK FOOTER //
// ./src/components/HostedQuikForm/index.jsx